import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';

export class StackTraceLine {
  file_path: string = '';
  line_number: number = 0;
  column_number: number = 0;

  class_name: string = '';
  function_name: string = '';

  toString() {
    let out: string[] = [];

    let line_file_path = '';

    if (this.file_path) line_file_path += `file\t\t${this.file_path}`;
    if (this.line_number != 0) line_file_path += ':' + this.line_number;
    if (this.column_number != 0) line_file_path += ':' + this.column_number;
    out.push(line_file_path);

    if (CONSTANTS__shared.IS_BROWSER) {
      const match = this.file_path.match(/@fs(\/.*)$/);

      if (match) {
        let file_open_link = `vscode://file:/${match[1]}`;

        let line_open_file = `open\t\t${file_open_link}`;

        out.unshift(decodeURIComponent(line_open_file));
      }
    }

    let line_function_name = 'function\t';

    if (this.class_name) line_function_name += `${this.class_name}`;
    if (this.function_name) line_function_name += `.${this.function_name}`;
    out.push(line_function_name);

    return out.join('\n');
  }
}
